import Image from 'next/image';
import {
  AppStoreButtonOutline,
  GooglePlayButtonOutline
} from '@goodneighbor/ui';
import {
  APP_STORE_URL,
  PLAY_STORE_URL
} from '@/components/PromotionalBanner/promotionalBanner.constants';
import phoneSrc from './assets/phone.png';
import phoneLongSrc from './assets/phone-long.png';
import StarCluster from './assets/star-cluster.svg';
import styles from './downloadBanner.module.scss';

export default function DownloadBanner() {
  return (
    <div className={styles.banner}>
      <div className={styles.copy}>
        <h3 className={styles.title}>Do Good, anytime, anywhere</h3>
        <p className={styles.description}>
          Download App to track events, enable seamless check-in, earn rewards
          and more.
        </p>
        <div className={styles.badges}>
          <AppStoreButtonOutline
            className={styles.badge}
            href={APP_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            size="md"
          />
          {PLAY_STORE_URL && (
            <GooglePlayButtonOutline
              className={styles.badge}
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              size="md"
            />
          )}
        </div>
      </div>
      <div className={styles.visual} aria-hidden>
        <StarCluster className={styles.starCluster} />
        <Image src={phoneSrc} alt="" className={styles.phone} />
        <Image src={phoneLongSrc} alt="" className={styles.phoneLong} />
      </div>
    </div>
  );
}
